/* Modulo: Video Shop — scroll-snap clip rail + muted in-view playback.
   Vanilla IIFE, no deps.

   Deliberately has NO player chrome: every card is a single <a> to the product,
   so there is nothing inside it to click but the link itself. Sound, lightboxes
   and variant pickers belong to section-video-social and section-shoppable-video. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  // A LIVE query, not a load-time boolean — a shopper who turns reduced motion
  // on mid-session must stop the clips without reloading (the as lesson).
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mqReduce && mqReduce.matches); }

  function init(root) {
    if (!root || root.__vspInit) return;
    var rail = root.querySelector('[data-vsp-track]');
    if (!rail) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-vsp-card]'));
    if (!cards.length) return;
    root.__vspInit = true;

    var prevBtn = root.querySelector('[data-vsp-prev]');
    var nextBtn = root.querySelector('[data-vsp-next]');
    var wantAutoplay = root.getAttribute('data-vsp-autoplay') === '1';

    /* ── arrows ────────────────────────────────────────────────────────── */
    function stepX() {
      var c = cards[0];
      var cs = getComputedStyle(rail);
      var g = parseFloat(cs.columnGap || cs.gap || '16') || 16;
      return (c ? c.getBoundingClientRect().width : 240) + g;
    }
    var raf = 0;
    function sync() {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = 0;
        // scrollLeft runs 0 -> negative under spec-compliant RTL, so the bounds
        // are measured on the magnitude (the bs/tsg lesson).
        var pos = Math.abs(rail.scrollLeft);
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (prevBtn) prevBtn.disabled = pos <= 2;
        if (nextBtn) nextBtn.disabled = pos >= max;
      });
    }
    function nudge(dir) {
      var by = stepX() * dir * (cards.length > 3 ? 2 : 1);
      rail.scrollBy({ left: by, behavior: reduced() ? 'auto' : 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { nudge(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { nudge(1); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    /* ── muted in-view playback ────────────────────────────────────────
       Only the single most-visible clip plays, so a rail of six does not
       decode six streams at once. Always muted: an autoplaying clip that
       makes noise is the thing shoppers hate most about this pattern, and
       there is no control to stop it here by design. */
    var videos = cards.filter(function (c) { return c.querySelector('[data-vsp-video]'); });

    function pauseAll(except) {
      for (var i = 0; i < videos.length; i++) {
        if (videos[i] === except) continue;
        var v = videos[i].querySelector('[data-vsp-video]');
        if (v && !v.paused) v.pause();
        videos[i].classList.remove('is-playing');
      }
    }
    function playMuted(card) {
      var v = card.querySelector('[data-vsp-video]');
      if (!v) return;
      pauseAll(card);
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});   // autoplay can be refused; not an error
      card.classList.add('is-playing');
    }

    var io = null;
    function startAutoplay() {
      if (io || !videos.length || !('IntersectionObserver' in window)) return;
      var ratios = {};
      videos.forEach(function (card, i) { card.__vspi = i; ratios[i] = 0; });
      io = new IntersectionObserver(function (entries) {
        for (var k = 0; k < entries.length; k++) ratios[entries[k].target.__vspi] = entries[k].intersectionRatio;
        var best = null, bestR = 0;
        for (var i = 0; i < videos.length; i++) {
          var r = ratios[i] || 0;
          if (r > bestR) { bestR = r; best = videos[i]; }
        }
        if (best && bestR >= 0.6) {
          if (!best.classList.contains('is-playing')) playMuted(best);
        } else {
          pauseAll(null);
        }
      }, { threshold: [0, 0.6, 0.9] });
      videos.forEach(function (card) { io.observe(card); });
    }
    function stopAutoplay() {
      if (io) { io.disconnect(); io = null; }
      pauseAll(null);
    }
    function applyMotionPreference() {
      if (wantAutoplay && !reduced()) startAutoplay();
      else stopAutoplay();
    }
    applyMotionPreference();
    if (mqReduce) {
      if (mqReduce.addEventListener) mqReduce.addEventListener('change', applyMotionPreference);
      else if (mqReduce.addListener) mqReduce.addListener(applyMotionPreference);
    }

    sync();
  }

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-vsp]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  // An identical <script src> still executes once per tag, so the document
  // listeners are wired at most once per page (the as/hpi lesson).
  if (!window.__moduloVspWired) {
    window.__moduloVspWired = true;
    document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
})();
